
import  axiosInstance  from "./config/axiosConfigs";
import { getToken } from "../cookie/authCookie";

export const GameAPI = {

  getGames: async function (clubId) {
    const response = await axiosInstance.request({
      url: `/games/club/` + clubId,
      method: "GET",
      timeout: 10000,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },
  getGamesByPlatform: async function () {
    const response = await axiosInstance.request({
      url: `/games/club`,
      method: "GET",
      timeout: 10000
    });
    return response.data;
  },
};